import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Signature} from '../../shared/models/signature.model';
import {ApiConfigService} from './api.config.service';
import {HttpCacheService} from '../services/http-cache.service';

@Injectable({providedIn: 'root'})
export class SignatureService {
  constructor(
    private http: HttpClient,
    private apiConfigService: ApiConfigService,
    private cache: HttpCacheService,
  ) {
  }

  setSignature(signature: Signature) {
    this.cache.invalidate('CheckInService:');
    return this.http.post(this.apiConfigService.setSignatureUrl(), signature);
  }
}
